// extracted by mini-css-extract-plugin
export default {"cuestionarioText":"DetalleCuestionario_cuestionarioText__znuWw"};